import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { Card, ScreenReaderContainer } from 'components';
import { Icon, Text } from 'components/chroma';

import { SpecialDetail } from 'scenes/motor/types';

const detailDescription: {
  [key in SpecialDetail]: string;
} = {
  [SpecialDetail.LicenceCancelled]:
    'Licence cancelled, suspended or disqualified?',
  [SpecialDetail.InsuranceClaimRefused]: 'An insurance claim refused?',
  [SpecialDetail.InsurancePolicyCancelled]:
    'An insurance policy cancelled by an insurer?',
  [SpecialDetail.DeniedPurchase]:
    'Been denied purchase of new or renewed insurance?',
  [SpecialDetail.ConvictedOrFinedOrPenalised]:
    'Been convicted, fined or penalised for any alcohol or drug related driving offence?',
  [SpecialDetail.None]: 'None of the above',
};

const CardWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SpecialDetailCard: FunctionComponent<{
  specialDetail: SpecialDetail;
  selected: boolean;
  onClick: () => void;
  screenReaderText: string;
}> = ({ specialDetail, selected, onClick, screenReaderText }) => (
  <Card
    id={specialDetail}
    selected={selected}
    center
    onClick={onClick}
    role="button"
  >
    <CardWrapper data-testid={`${specialDetail}${selected ? '-selected' : ''}`}>
      <Icon name="checkCircle" margin={{ right: 5 }} />
      <Text>{detailDescription[specialDetail]}</Text>
      <ScreenReaderContainer>{screenReaderText}</ScreenReaderContainer>
    </CardWrapper>
  </Card>
);
